import { createDefaultPaywallProfile } from '@shared/default-data'

export const DEFAULTS = createDefaultPaywallProfile('')
